<script lang="ts">
  import Button from '$lib/components/Button.svelte';
  import type { ButtonColor } from '$lib/components/ButtonDefinitions';
  import H from '$lib/components/H.svelte';
  import { autorun } from 'mobx';

  import type { UserLessonStore } from 'shared/src/user/userLessons/user.lesson.store';
  import { onDestroy } from 'svelte';

  export let lesson: UserLessonStore;
  export let lessonPage: UserLessonStore['pages'][number];

  let props: ReturnType<typeof getProps>;
  const destroy = autorun(() => {
    props = getProps();
  });

  function getProps() {
    const pageIndex = lesson.pages.findIndex((p) => p.id === lessonPage.id);

    return {
      lessonTitle: lesson.title,
      pageIndex,
      pages: lesson.pages.map((p, index) => {
        let isCurrent = index === pageIndex;
        let color: ButtonColor = 'gray';
        if (p.isAvailable) color = 'cyan';
        if (isCurrent) color = 'green';
        return {
          id: p.id,
          color,
          type: p.type,
          isAvailable: p.isAvailable,
          isComplete: p.isComplete,
          isCurrent,
        };
      }),
    };
  }

  onDestroy(destroy);
</script>

<div class="md:hidden w-full flex">
  {#each props.pages as page, pageNumber}
    <Button
      as="a"
      href={page.id}
      color={page.color}
      disabled={!page.isAvailable}
      class="flex-grow shadow-none rounded-none border border-gray"
    >
      <span class="sr-only">Page {pageNumber} or {props.pages.length}</span>
    </Button>
  {/each}
</div>
<H level={1} class="md:hidden card-padding card-margins text-base">{props.lessonTitle}</H>
